"use strict";
var keyMirror = require("fbjs/lib/keyMirror");
var ReactMultiChildUpdateTypes = keyMirror({
  INSERT_MARKUP: null,
  MOVE_EXISTING: null,
  REMOVE_NODE: null,
  SET_MARKUP: null,
  TEXT_CONTENT: null
});
module.exports = ReactMultiChildUpdateTypes;
